<template>
  <div class="list-view-detail list-view-detail-commingsoon">
    <template v-for="(cell, index) in cellList">
      <preview-instant-player-cell v-if="isAutoPlayerCell(cell)"
                                   :key="index"
                                   :cell-info="cell"
                                   :thumbnail-info="thumbnailInfo"
                                   :isPlayerMute="isPlayerMute"
                                   :setPlayerMuteStateFn="setPlayerMuteState"
      ></preview-instant-player-cell>
      <PreviewImageCell v-else
                        :key="index"
                        :cell-info="cell"
                        :thumbnail-info="thumbnailInfo" />
    </template>

  </div>
</template>
<script>
import Vue from 'vue'
import PreviewInstantPlayerCell from '@/components/model/cell/PreviewInstantPlayerCell'
import { EVENT_TYPE_MOUSE_ENTER, EVENT_TYPE_MOUSE_LEAVE } from '@/common/resources/const'
import canAutoPlay from 'can-autoplay'
import PreviewImageCell from '@/components/model/cell/PreviewImageCell'
import _ from 'lodash'
export default {
  name: 'PreviewCellWrapper',
  components: {
   PreviewInstantPlayerCell,
    PreviewImageCell
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  data () {
    return {
      isPlayerMute: false,
      firedEventMap: {}
    }
  },
  methods: {
    clearAlreadyFiredEvent (contentId) {
      const keyList = Object.keys(this.firedEventMap)
      console.log('keyList: ', keyList)
      keyList.forEach((key) => {
        if (contentId !== key) {
          clearTimeout(this.firedEventMap[key].timer)
          setTimeout(() => {
            if (this.firedEventMap[key]) {
              console.log(this.firedEventMap)
              this.firedEventMap[key].context.disableVideoMode()
              this.firedEventMap[key].context = null
              delete this.firedEventMap[key]
            }
          }, 0)
        }
      })
    },
    fireVideoInitEvent (contentId, context) {
      this.firedEventMap[contentId] = {
        timer: setTimeout(() => {
          canAutoPlay.video().then(({ result }) => {
            if (!result) {
              sessionStorage.setItem(this.MUTE_STATE_KEY, 'true')
              this.isPlayerMute = true
            }
            context.enableVideoMode()
          }).catch(() => {
            context.enableVideoMode()
          })
        }, 1000),
        context: context
      }
    },
    startPlayerInit (context) {
      const { contentId } = context.getInstancePlayMeta()
      this.clearAlreadyFiredEvent(contentId, context)
      this.fireVideoInitEvent(contentId, context)
    },
    disposePlayer () {
      this.clearAlreadyFiredEvent('EMPTY')
    },
    setPlayerMuteState (state) {
      sessionStorage.setItem(this.MUTE_STATE_KEY, String(state))
      this.isPlayerMute = sessionStorage.getItem(this.MUTE_STATE_KEY) === 'true'
    },
    getMuteState () {
      const isMute = sessionStorage.getItem(this.MUTE_STATE_KEY)
      if (isMute === null) {
        sessionStorage.setItem(this.MUTE_STATE_KEY, 'true')
      }
      return sessionStorage.getItem(this.MUTE_STATE_KEY) === 'true'
    },
    initialize () {
      this.isPlayerMute = this.getMuteState()
    },
    isAutoPlayerCell (cell) {
      return _.get(cell, 'event_list', []).length > 0
    }
  },
  created () {
    this.initialize()
    Vue.prototype.$previewEvents = new Vue()
    this.$previewEvents.$on(EVENT_TYPE_MOUSE_ENTER, this.startPlayerInit)
    this.$previewEvents.$on(EVENT_TYPE_MOUSE_LEAVE, this.disposePlayer)
  },
  beforeDestroy () {
    this.$previewEvents.$off(EVENT_TYPE_MOUSE_ENTER, this.startPlayerInit)
    this.$previewEvents.$off(EVENT_TYPE_MOUSE_LEAVE, this.disposePlayer)
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/preview-cell.scss"></style>
